<template>
  <div class="wall" :style="wallCss(wallConfig)">
    <div class="row" ref="row" v-for="(row, i) in m" :key="i" :style="rowCss(wallConfig, [i, 0])">
      <BrickComponent v-for="(brick, j) in row" :key="j" :style="brickCss(wallConfig, [i, j])" :i="[i, j]" />
    </div>
  </div>
</template>

<script>
import BrickComponent from './BrickComponent.vue'
import EditConfigModal from './modals/EditConfigModal.vue'

import { loadWall, getPresetSource } from '@/util/walls/load-wall-bpl.js'
import { compile } from '@/util/bpl/compiler.js'
import { emitter } from '@/util/emitter.js'

import { wallCss, rowCss, brickCss } from '@/util/bricks/brick-css.js'
import { brickMatrix } from '@/util/bricks/brick-matrix.js'
import * as modal from '@/components/modals/ModalComponent.vue'


export const getQueryParam = () => {
  const url = new URL(window.location);
  return url.searchParams.get('w') ?? 'default';
}

export default {
  name: 'WallComponent',
  components: {
    BrickComponent,
  },
  data() {
    return {
      m: [],
      wall_w: window.innerWidth,
      wall_h: window.innerHeight,
      wallConfig: compile(getPresetSource('default')),
    }
  },
  computed: {
  },
  methods: {
    wallCss,
    rowCss,
    brickCss,
    brickMatrix,
    setWall(config = this.wallConfig) {
      this.wallConfig = config;
      this.m = this.brickMatrix(
        config,
        { w: this.wall_w, h: this.wall_h }
      );
    },
    handleResize() {
      this.wall_w = window.innerWidth;
      this.wall_h = window.innerHeight;

      this.setWall();
    },
  },
  mounted() {
    emitter.on('load-wall', () => {
      const config = loadWall();
      this.setWall(config);

      if (modal.getQueryParam()) {
        emitter.emit('show-modal', {
          modal: modal.getQueryParam(),
          data: config,
        });
      }
    });
    emitter.emit('load-wall');

    emitter.on('apply-wall', (config) => {
      this.setWall(config);
    });

    emitter.on('show-modal-editor', (data) => {
      if (!data) data = this.wallConfig;
      if (Object.keys(data).length === 0) data = compile(getPresetSource('default'));

      emitter.emit('show-modal', {
        modal: EditConfigModal.name,
        data,
      });
    });
    window.addEventListener('resize', this.handleResize);
  },
}
</script>

<style scoped>
.wall {
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  display: flex;
  flex-wrap: wrap;
  justify-content: center;

  overflow: hidden;
}
</style>
